const AllTalentRequest = () => import("./views/AllTalentRequest.vue");
const CreateTalentRequest = () => import("./views/CreateTalentRequest.vue");
const ViewTalentRequest = () => import("./views/ViewTalentRequest.vue");
const ApprovalTalentRequest = () => import("./views/ApprovalTalentRequest.vue");
const Settings = () => import("./views/Settings.vue");
const SettingsManageTalentRequisition = () =>
  import("./views/SettingsManageTalentRequisition.vue");
const CreateManageTalentRequisition = () =>
  import("./views/CreateManageTalentRequisition.vue");
const EditManageTalentRequisition = () =>
  import("./views/EditManageTalentRequisition.vue");

export default [
  {
    path: "talent-request",
    component: AllTalentRequest,
  },
  {
    path: "talent-request/create",
    component: CreateTalentRequest,
  },
  {
    path: "talent-request/view/:id",
    component: ViewTalentRequest,
  },
  {
    path: "approval",
    component: ApprovalTalentRequest,
  },
  {
    path: "settings",
    component: Settings,
  },
  {
    path: "manage-talent-requisition-settings",
    component: SettingsManageTalentRequisition,
  },
  {
    path: "manage-talent-requisition-settings/create",
    component: CreateManageTalentRequisition,
  },
  {
    path: "manage-talent-requisition-settings/edit/:id",
    component: EditManageTalentRequisition,
  },
];
